<div>
  <div mat-dialog-content>
    <p [innerHtml]="passedData.message"></p>
  </div>
  <div mat-dialog-actions class="dialog-actions">
    <button slb-secondary-button id="agora_vi_cnfm_dialog_cancel_btn" [mat-dialog-close]="ConfirmationResult.Cancel">Cancel</button>
    <button slb-button id="agora_vi_cnfm_dialog_confirm_btn" [mat-dialog-close]="ConfirmationResult.Confirmed">Confirm</button>
  </div>
</div>
